module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_3016.c711a380.png";